
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import eXXcellentLogoQuadratSVG from './xx-Logoicon-Verlauf-quadrat.svg'; 
import { LinkButton } from '@backstage/core-components';
import { Box } from '@backstage/ui';



export default function LogoCard() {
  return (
      <Box display="block" height="100%" width="100%" style={{overflow: 'hidden'}}>
        <img style={{height: '100%', padding: '0px'}} src={eXXcellentLogoQuadratSVG} alt="eXXcellent logo"/>
      </Box>
  );
}
export const Content = LogoCard;
export const Actions = function LogoActions() {
  return (
    <LinkButton target="blank" 
          to='https://www.exxcellent.de/confluence'          
          >Open Confluence</LinkButton>
  )
}

export const logoWidget = HomePageWidgetBlueprint.make({
  name: 'logo-widget',
  params: {
    name: 'LogoWidget',        
    description: 'An eXXcellent logo widget for the homepage',
    components: () =>
      import('./LogoCard').then(m => ({
        Content: m.Content, 
        Actions: m.Actions       
      })),      
    layout: {
      height: { minRows: 5, defaultRows: 5, maxRows: 5 },
      width: { minColumns: 3, defaultColumns: 3, maxColumns: 3 },      
    }    
  },
})as any;